module.exports = __webpack_public_path__ + "resources/sass/fn/fonts/OpenSans-Light-webfont.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/resources/sass/fn/fonts/OpenSans-Light-webfont.ttf
// module id = 347
// module chunks = 0